import { registryApi } from '../clients/AxiosClients'
import i18n from '../../VueI18n'

/**
 * Retorna todos os Especies cadastradas no banco de dados
 */
const getAllEspecies = async () => {
	return registryApi.get('v1/Especie')
}

/**
 * Retorna todas as especies para o componente de DropdownFk
 */
const getDropdownEspecies = async () => {
	const {
		data: { result },
	} = await registryApi.get('v1/Especie')

	return result.map((especie) => {
		return {
			id: especie.id,
			[i18n.t('code')]: `ES-${especie.espe_cd_codigo}`,
			[i18n.t('description')]: especie.espe_ds_descricao,
			[i18n.t('name')]: especie.espe_ds_nome || '-',
		}
	})
}

/**
 * Cadastrar nova Especies no banco de dados
 * @param {Object} body Especie que será cadastrada
 */
const createEspecie = async (body) => {
	return registryApi.post('v1/Especie', body)
}

/**
 * Atualiza Especie no banco de dados
 * @param {Object} body Especie que será atualizada
 */
const updateEspecie = async (body) => {
	return registryApi.put('v1/Especie', body)
}

/**
 * Lista dos ids de Especie que devem ser excluidos do banco de dados
 * nome do parametro deve ser data pois método DELETE do axios obrigatoriamente recebe um argumento 'data'
 * @param {Array} data Lista dos ids de Especie
 */
const deleteEspecieByIdList = async (data) => {
	return registryApi.delete('v1/Especie/DeleteByIdList', { data })
}

export { getAllEspecies, getDropdownEspecies, createEspecie, updateEspecie, deleteEspecieByIdList }
